const MultipleOptions = props => {
  if (
    Array.isArray(props.mvcAttributes) &&
    (props.mvcAttributes.length === 0 || props.mvcAttributes.length > 3)
  ) {
    return '';
  }

  const selectedAttributeKeys = Object.keys(props.selectedMvcAttributes);
  if (selectedAttributeKeys.length > 3) {
    // Won't show configuration if there are > 3 config options
    return '';
  }

  const attribute = selectedAttributeKeys.sort().map(key => {
    return SingleOption({
      selectedOption: props.selectedMvcAttributes[key],
      attributeName: key,
      option: props.mvcAttributes[key],
      className: props.className
    });
  });
  const div = `<div>${attribute}</div>`;
  return div.replace(/,/g, '');
};

const SingleOption = ({ className, attributeName, option, selectedOption }) => {
  const options = Object.keys(option.options).map(keyName => {
    const selected = selectedOption === keyName ? ' selected' : '';
    return `
<option value="${keyName}"${selected}>
    ${option.options[keyName].label}
</option>
      `;
  });

  return `
<div class="${className.DETAILS.OPTIONS.WRAPHEADER}">
    <label class="${className.DETAILS.OPTIONS.LABEL}" for="mvc-select-${attributeName}">${option.name}</label>
    <div class="${className.DETAILS.OPTIONS.WRAPOPTIONS}">
        <select name="${attributeName}" id="mvc-select-${attributeName}" class="${className.DETAILS.OPTIONS.SELECT}">
            ${options}
        </select>
    </div>
</div>
  `;
};

export default MultipleOptions;



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/components/Options/options.js
 **/